import { motion } from "framer-motion";
import { useLenis } from "lenis/react";
import { ArrowUpRight } from "lucide-react";

const links = [
  { label: "Philosophy", href: "#features", testId: "nav-link-philosophy" },
  { label: "Manifesto", href: "#manifesto", testId: "nav-link-manifesto" },
  { label: "Contact", href: "#contact", testId: "nav-link-contact" },
];

export default function Navbar() {
  const lenis = useLenis();
  const go = (href) => (e) => {
    e.preventDefault();
    if (lenis) lenis.scrollTo(href, { offset: -70, duration: 1.4 });
    else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-4 inset-x-0 z-50 px-4"
    >
      <nav
        data-testid="navbar"
        className="max-w-5xl mx-auto flex items-center justify-between gap-4 rounded-full border border-stone-300/40 bg-sand/80 backdrop-blur-xl backdrop-saturate-150 px-5 sm:px-7 py-3 shadow-[0_8px_30px_rgb(0,0,0,0.05)]"
      >
        <a href="#top" onClick={go("#top")} data-testid="nav-brand" className="font-serif text-xl sm:text-2xl font-semibold tracking-tight">
          Vacansee<span className="text-bronze">.</span>
        </a>
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={go(l.href)}
              data-testid={l.testId}
              className="link-underline text-sm font-medium text-ink-soft hover:text-ink transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <span
            data-testid="nav-coming-soon-badge"
            className="hidden sm:flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] uppercase text-ink-soft"
          >
            <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-bronze" />
            Coming Soon
          </span>
          <button
            onClick={go("#coming-soon")}
            data-testid="nav-cta-button"
            className="group flex items-center gap-1.5 rounded-full bg-ink text-sand text-xs sm:text-sm font-medium px-4 sm:px-5 py-2 transition-all duration-300 hover:bg-bronze hover:shadow-[0_8px_24px_rgba(200,90,50,0.35)]"
          >
            Get Early Access
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </nav>
    </motion.header>
  );
}
